import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClientWrapper } from './httpclientwrapper';
import { CheckPlatformService } from '../services/check-platform.service';
import { Shared } from '../models/shared';

@Injectable({
  providedIn: 'root'
})
export class RecommendationService {

  isBrowser: boolean = false;
  baseUrl: string = Shared.baseUrl;
  RecommendationInfoEvent: EventEmitter<any> = new EventEmitter<number>();

  constructor(private http: HttpClientWrapper,
    private checkPlatformService: CheckPlatformService) {

    if (this.checkPlatformService.isBrowser()) {
      this.isBrowser = true;
    }
  }

  SendRecommendationForCompany(companyId:number, companyUrl:string, recommendToEmail:string, recommendedByUserId:number): Observable<any> {
    let url:string = "";

    if(companyId !== undefined && companyId != null && companyId != 0)
    {
      url += companyId;
    }

    if(companyUrl !== undefined && companyUrl != null && companyUrl != "")
    {
      url += "&companyUrl=" + companyUrl;
    }

    if(recommendToEmail !== undefined && recommendToEmail != null && recommendToEmail != "")
    {
      url += "&recommendToEmail=" + recommendToEmail;
    }

    if(recommendedByUserId !== undefined && recommendedByUserId != null && recommendedByUserId != 0)
    {
      url += "&recommendedByUserId=" + recommendedByUserId;
    }
    
    return this.http.PostAsync<any>(this.baseUrl + "api/Companies/recommend/company?recommendedCompanyId=" + url, null);
  }

  SendRecommendationForJob(jobId: number, jobDetailUrl: string, recommendToEmail: string, recommendedByUserId: number): Observable<any> {
    let url: string = "";

    if (jobId !== undefined && jobId != null && jobId != 0) {
      url += jobId;
    }

    if (jobDetailUrl !== undefined && jobDetailUrl != null && jobDetailUrl != "") {
      url += "&jobDetailUrl=" + jobDetailUrl;
    }

    if (recommendToEmail !== undefined && recommendToEmail != null && recommendToEmail != "") {
      url += "&recommendToEmail=" + recommendToEmail;
    }

    if (recommendedByUserId !== undefined && recommendedByUserId != null && recommendedByUserId != 0) {
      url += "&recommendedByUserId=" + recommendedByUserId;
    }

    return this.http.PostAsync<any>(this.baseUrl + "api/Jobs/recommend/job?recommendedJobId=" + url, null);
  }

  SendRecommendationForCandidate(recommendedUserId:number, profileUrl:string, recommendToEmail:string, recommendedByUserId:number): Observable<any> {
    let url:string = "";

    if(recommendedUserId !== undefined && recommendedUserId != null && recommendedUserId != 0)
    {
      url += recommendedUserId;
    }

    if(profileUrl !== undefined && profileUrl != null && profileUrl != "")
    {
      url += "&profileUrl=" + profileUrl;
    }

    if(recommendToEmail !== undefined && recommendToEmail != null && recommendToEmail != "")
    {
      url += "&recommendToEmail=" + recommendToEmail;
    }

    if(recommendedByUserId !== undefined && recommendedByUserId != null && recommendedByUserId != 0)
    {
      url += "&recommendedByUserId=" + recommendedByUserId;
    }
    
    return this.http.PostAsync<any>(this.baseUrl + "api/UserProfiles/recommend/candidate?recommendedUserId=" + url, null);
  }

  OpenRecommendationModalWithId() {
    if (this.isBrowser) {
     let element= document.getElementById("OpenRecommendationModal");

     if(element !== undefined && element != null){
       element.click();
     }
    }
  }

  CloseRecommendationModalWithId() {
    if (this.isBrowser) {
     let element = document.getElementById("closesendRecommendationModal");
     
     if(element !== undefined && element != null){
       element.click();
     }
    }
  }
}